(function(){
  function id(){
    if (crypto.randomUUID) return crypto.randomUUID();
    var bytes=new Uint8Array(16);crypto.getRandomValues(bytes);
    return Array.from(bytes,function(b){return b.toString(16).padStart(2,'0');}).join('');
  }
  function visitor(){
    var value='';try{value=localStorage.getItem('mm_preview_visitor_id')||'';}catch(error){}
    if(!/^[a-zA-Z0-9-]{16,80}$/.test(value)){value=id();try{localStorage.setItem('mm_preview_visitor_id',value);}catch(error){}}
    return value;
  }
  async function request(url,options,timeout){
    var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},timeout||15000);
    try{var response=await fetch(url,Object.assign({},options,{signal:controller.signal}));return {ok:response.ok,status:response.status,data:await response.json()};}
    finally{clearTimeout(timer);}
  }
  function safeUrl(value){try{var u=new URL(value);return typeof value==='string'&&u.protocol==='https:'&&!u.username&&!u.password;}catch(error){return false;}}
  function unknown(data){return data&&(data.status==='unknown'||data.outcomeUnknown===true||['GENERATION_OUTCOME_UNKNOWN','GENERATION_SAVE_UNCONFIRMED'].indexOf(data.code)>=0);}
  function businessError(data){return !data||data.error||data.ok===false||(data.code!=null&&[0,200,'OK','SUCCESS'].indexOf(data.code)<0);}
  function delay(data,errors){return Math.min(10000,Math.max(1000,Number(data&&data.retryAfterMs)||3000)*(errors?Math.pow(2,errors-1):1));}
  function create(options){
    var active=null,epoch=0,storageKey='mm_preview_pending_v2:'+options.api+':'+options.key;
    function current(task){return active===task&&task.epoch===epoch&&(!options.current||options.current(task));}
    function save(task){try{sessionStorage.setItem(storageKey,JSON.stringify({requestId:task.requestId,fields:task.fields,url:task.url,taskId:task.taskId,imageId:task.imageId,generationId:task.generationId,state:task.state,counted:task.counted}));}catch(error){}}
    function state(task,value){task.state=value;save(task);}
    function problem(task,value){if(!current(task))return;clearTimeout(task.timer);state(task,value);options.onError(task,value);}
    function remember(task,data){
      if(!data)return true;
      task.metadata=task.metadata||{};
      ['modelUsed','promptUsed','model','prompt','aiModel','aiPrompt','ai_model','ai_prompt'].forEach(function(key){if(typeof data[key]==='string')task.metadata[key]=data[key];});
      for(var key of ['taskId','imageId','generationId'])if(typeof data[key]==='string'&&data[key]){
        if(task[key]&&task[key]!==data[key])return false;task[key]=data[key];
      }
      return true;
    }
    function accepted(task){if(!task.counted){task.counted=true;save(task);if(options.onAccepted)options.onAccepted(task);}}
    function consume(task,response,polling,errors){
      if(!current(task))return;
      var data=response.data;
      if(!remember(task,data)){problem(task,'blocked');return;}
      if(unknown(data)){problem(task,'unknown');return;}
      if(data&&data.status==='failed'){problem(task,'failed');return;}
      if(data&&data.status==='unavailable'&&data.retryable===true){schedule(task,errors+1,data);return;}
      if(data&&data.code==='REQUEST_ID_SCOPE_MISMATCH'){problem(task,'blocked');return;}
      var known=data&&['succeeded','processing','pending','queued'].indexOf(data.status)>=0;
      if(!response.ok||(!known&&businessError(data))){
        if(polling&&(response.status>=500||response.status===404||response.status===408||response.status===429)){schedule(task,errors+1,data);return;}
        problem(task,response.status>=400&&response.status<500&&response.status!==408&&response.status!==429?'blocked':'unknown');return;
      }
      if(data.status==='succeeded'){
        if(!safeUrl(data.resultUrl||data.thumbnailUrl)||!safeUrl(data.sourceImageUrl)){problem(task,'unknown');return;}
        accepted(task);state(task,'succeeded');clearTimeout(task.timer);try{sessionStorage.removeItem(storageKey);}catch(error){}
        options.onSuccess(Object.assign({},task.metadata,data),task);return;
      }
      if(!task.taskId){problem(task,'unknown');return;}
      accepted(task);state(task,'processing');
      if(!polling){options.onWaiting(task);poll(task,0);return;}
      if(['processing','pending','queued',undefined].indexOf(data.status)>=0)schedule(task,0,data);else problem(task,'unknown');
    }
    function schedule(task,errors,data){
      if(!current(task))return;
      if(errors>3||Date.now()>=task.deadline){problem(task,'unknown');return;}
      clearTimeout(task.timer);task.timer=setTimeout(function(){poll(task,errors);},delay(data,errors));
    }
    async function poll(task,errors){
      if(!current(task)||task.checking)return;
      if(Date.now()>=task.deadline){problem(task,'unknown');return;}
      task.checking=true;
      try{var response=await request(options.api+'/api/status?taskId='+encodeURIComponent(task.taskId)+(task.imageId?'&imageId='+encodeURIComponent(task.imageId):''),{method:'GET'});if(current(task))consume(task,response,true,errors);}
      catch(error){schedule(task,errors+1);}finally{task.checking=false;}
    }
    async function submit(task){
      if(!current(task)||task.submitting)return;
      if(!task.uploadFile){problem(task,'file_lost');return;}
      task.submitting=true;task.deadline=Date.now()+360000;state(task,'processing');
      var form=new FormData();form.append('image',task.uploadFile,task.uploadFile.name);
      Object.keys(task.fields).forEach(function(key){if(task.fields[key]!==''&&task.fields[key]!=null)form.append(key,String(task.fields[key]));});
      form.append('requestId',task.requestId);
      try{consume(task,await request(task.url,{method:'POST',body:form},30000),false,0);}
      catch(error){problem(task,'unknown');}finally{task.submitting=false;}
    }
    function resume(){
      var task=active;if(!task||!current(task)||task.submitting||task.checking||task.state==='preparing')return;
      if(task.state==='blocked'){options.onError(task,'blocked');return;}
      clearTimeout(task.timer);task.deadline=Date.now()+360000;options.onWaiting(task);state(task,'processing');
      if(task.taskId)poll(task,0);else submit(task);
    }
    function pending(file,fields){
      if(!active||active.file!==file||JSON.stringify(active.inputFields)!==JSON.stringify(fields)||['preparing','processing','unknown','blocked','file_lost'].indexOf(active.state)<0)return false;
      if(active.state!=='preparing'&&active.state!=='processing')resume();return true;
    }
    async function start(file,fields,url){
      clearTimeout(active&&active.timer);epoch++;
      var task={requestId:id(),fields:Object.assign({},fields,{visitorId:visitor(),generationType:'initial'}),inputFields:Object.assign({},fields),file:file,url:url,epoch:epoch,state:'preparing',deadline:Date.now()+360000};active=task;save(task);
      try{task.uploadFile=await options.prepare(file);if(current(task))await submit(task);}catch(error){problem(task,'invalid_image');}
    }
    function invalidate(){if(active)clearTimeout(active.timer);epoch++;active=null;}
    function restore(fields){
      if(active)return false;
      try{var stored=JSON.parse(sessionStorage.getItem(storageKey)||'null');if(!stored||!stored.requestId||!stored.fields||stored.fields.visitorId!==visitor()||stored.url!==options.processUrl)return false;
        for(var key of Object.keys(fields))if(String(stored.fields[key]||'')!==String(fields[key]||'')){
          if(key==='backgroundPreset'&&!fields[key]&&options.allowedBackground&&options.allowedBackground.indexOf(stored.fields[key])>=0)continue;
          return false;
        }
        if(options.onRestoreContext)options.onRestoreContext(stored.fields);
        active=Object.assign(stored,{epoch:++epoch,deadline:Date.now()+360000,state:'unknown'});options.onError(active,active.taskId?'unknown':'file_lost');return true;
      }catch(error){return false;}
    }
    return {start:start,pending:pending,resume:resume,invalidate:invalidate,restore:restore,current:function(){return active;},imageError:function(){if(active)problem(active,'unknown');}};
  }
  window.MMPreviewRequest={create:create,id:id,visitor:visitor,request:request,safeUrl:safeUrl,unknown:unknown,delay:delay};
  document.dispatchEvent(new Event('mm:preview-request-ready'));
})();
